<script setup lang="ts">
//
</script>

<template>
	<div
    class="cp-box"
  >
			<slot />
	</div>
</template>

<style lang="scss">
	.cp-box {
    @apply
      pl-[max(1rem,env(safe-area-inset-left))]
      pr-[max(1rem,env(safe-area-inset-right))]

      xl:(
        pl-[max(4rem,env(safe-area-inset-left))]
        pr-[max(4rem,env(safe-area-inset-right))]
      )
    ;

	}
</style>
